import './style.scss';
import '../../node_modules/tiny-slider/src/tiny-slider.scss';

// Slider - Library import example
import { tns } from "tiny-slider"
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

import { CountUp } from 'countup.js';

document.addEventListener( 'DOMContentLoaded', () => {
	// Scroll Trigger for header
	const header = document.querySelector( "header.wp-block-template-part" )
	const observer = new IntersectionObserver( 
		( [e] ) => e.target.classList.toggle( "is-pinned", e.intersectionRatio < 1 ),
		{ threshold: [0] }
	);
	observer.observe( header );

	// Lazy load fade in
	document.querySelectorAll( 'img[loading="lazy"]' ).forEach( ( img ) => {
		if( img.complete === true ) {
			img.classList.add( 'has-loaded' );
		}
		img.addEventListener( "load", ( e ) => {
			e.target.classList.add( 'has-loaded' );
		} );
	} );

	// Copyright Year
	document.querySelectorAll(".copyright").forEach( ( p ) => { 
		p.innerHTML = p.innerHTML.replace( '{YEAR}', new Date().getUTCFullYear() );
	} );

	// Home parallax
	let mm = gsap.matchMedia();

	// mm.add("(min-width: 782px)", () => {
	if( document.querySelector( ".wp-block-cover.is-style-parallax .wp-block-cover__image-background" ) ) {
		largeParallax();
	}

	if( document.querySelector( ".entry-content > .wp-block-cover:not(.is-style-parallax)" ) ) {
		smallParallax();
	}

	// Column Fade
	document.querySelectorAll( ".fade-columns" ).forEach( block => {
		gsap.from( block, {
			scrollTrigger: {
				start: 'top 90%',
				end: 'bottom top',
				trigger: block,
				toggleClass: 'animate',
				once: true,
				onToggle: () => {
					initCountUps( block );
				}
			}
		});
	} );
	// } );

	document.querySelectorAll( '.is-style-count-numbers' ).forEach( title => {
		// parseFloat( title.innerHTML )
		const original = title.innerHTML;
		const regex = /[0-9]{1,100}/g;
		const matches = [...original.matchAll( regex )];
		matches.forEach( match => {
			title.innerHTML = title.innerHTML.replace( match[0], `<span class='count-me-up' data-total='${match[0]}'>0</span>` );
		} );
	} );

	
	if( document.getElementById("monford-map") ) {
		// Map info clicker
		// const infoWindow = document.querySelectorAll( "#monford-map .info-window" );
		document.querySelectorAll( "#monford-map .marker" ).forEach( link => {
			link.addEventListener( 'click', ( e ) => {
				// console.log( 'this' );
				const target = e.target.closest( ".marker" );
				const surround = document.querySelector( "#monford-map svg" );
				const width = surround.viewBox.baseVal.width;
				const height = surround.viewBox.baseVal.height;
				const infoWindow = target.closest('#monford-map').querySelector('.info-window');
				if( target && infoWindow ) {
					const left = parseFloat( target.dataset.x ) / width * 100;
					const top = parseFloat( target.dataset.y ) / height * 100;
					const content = target.dataset.content;
					// console.log( , target.dataset.y );
					infoWindow.innerHTML = "<p>" + content.replace("|", "<br />") + "</p>";
					infoWindow.style.top = `${top}%`;
					infoWindow.style.left = `${left}%`;
					infoWindow.style.display = "block";
				}
			 } ) 
		} );

		// Tabs change
		const tabOrder = ["INF", "RES", "NRG"];
		document.querySelectorAll( "a" ).forEach( link => {
			link.addEventListener( "click", ( e ) => {
				if( e.target.closest( 'a' ).classList.contains( 'ui-tabs-anchor' ) ) {
					const a = e.target.closest( 'a' );
					if( a.closest( '.our-project-tabs' ) ) {
						const tab = a.closest( '.wp-block-getwid-tabs__nav-link' );
						const position = [...tab.parentElement.children].indexOf(tab);
						const tabId = tabOrder[position];
						document.querySelectorAll("#monford-map svg > *:not(#AUS)").forEach( g => g.classList.remove( "is-visible" ) );
						document.querySelectorAll("#monford-map svg #" + tabId).forEach( g => g.classList.add( "is-visible" ) );
					}
				}
			} );
		} );
		// First time
		document.querySelectorAll("#monford-map svg #INF").forEach( g => g.classList?.add( "is-visible" ) );
	}
	
	// Project slider
	document.querySelectorAll( '.projects-slider .wp-block-post-template' ).forEach( projectSlider => {
		const slider = tns( {
			container: projectSlider,
			slideBy: 'page',
			autoplay: true, 
			items: 1,
			gutter: 0,
			autoplayButton: false,
			controls: false,
			navPosition: 'bottom',
			responsive: {
				782: {
					gutter: 20,
					items: 2
				}
			}
		} );
	} );

} );

const initCountUps = ( block ) => {
	block.querySelectorAll( ".count-me-up" ).forEach( cmu => {
		const countMeUp = new CountUp( cmu, cmu.dataset.total, {
				duration: 4,
			} );
		countMeUp.start();
	} );
}

const smallParallax = () => {
	document.querySelectorAll( '.entry-content > .wp-block-cover:not(.is-style-parallax)' ).forEach( smallCover => {
		const background =  smallCover.querySelector( ".wp-block-cover__image-background" );
		if( !background ) {
			return;
		}

		const imageOffset = background.offsetHeight;
		// const containerOffset = smallCover.querySelector( ".wp-block-cover__inner-container" ).offsetHeight;

		const tl = gsap.timeline( {
			scrollTrigger: {
				trigger: smallCover,
				start: "top bottom", // " + headerHeight + "px
				end: "bottom top",
				scrub: true,
				// markers: true
			}
		} );

		tl.fromTo( background, 
			{ y: imageOffset * 0.125 * -1, ease: "none" },
			{ y: imageOffset * 0.125, ease: "none" }
		)

		// tl.from( 
		// 	background,
		// 	{ y: imageOffset / 3 * -1, ease: "none" },
		// 	0
		// )
		// tl.to( 
		// 	background,
		// 	{ y: imageOffset / 3, ease: "none" },
		// 	0
		// )
	} );
}

const largeParallax = () => {
	// const headerHeight = document.querySelector( "header.wp-block-template-part" ).offsetHeight;
	const imageOffset = document.querySelector( ".wp-block-cover.is-style-parallax .wp-block-cover__image-background" ).offsetHeight;
	const containerOffset = document.querySelector( ".wp-block-cover.is-style-parallax .wp-block-cover__inner-container" ).offsetHeight;
	
	const tl = gsap.timeline( {
		scrollTrigger: {
			trigger: ".wp-block-cover.is-style-parallax",
			start: "top top", // " + headerHeight + "px
			end: "bottom top",
			scrub: true,
			// markers: true
		}
	} );
	
	tl.to( 
		".wp-block-cover.is-style-parallax .wp-block-cover__image-background",
		{ y: imageOffset / 3, ease: "none" },
		0
	)
	tl.to(
		".wp-block-cover.is-style-parallax .wp-block-cover__inner-container",
		{ y: containerOffset * 0.95, ease: "none", opacity: 0 },
		0
	)
}